module.exports = __webpack_public_path__ + "img/card4hover.0ebf5b7f.svg";